module.exports = __webpack_public_path__ + "img/hydefault.20483451.jpg";